import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatMenuTrigger } from "@angular/material/menu";
import { Subject } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  takeUntil,
} from "rxjs/operators";
import { Person } from "src/app/shared/Models/read";
import { OutsideSurveyService } from "src/app/shared/services/outside-survey.service";

@Component({
  selector: "app-contact-search",
  templateUrl: "./contact-search.component.html",
  styleUrls: ["./contact-search.component.scss"],
})
export class ContactSearchComponent implements OnInit, OnDestroy {
  @ViewChild("menuTrigger") menuTrigger: MatMenuTrigger;
  searchResults: Person[];
  searchInput: FormControl = new FormControl();
  selectedContact: Person;
  @Output() selectResult = new EventEmitter<any>();
  @Output() newContact = new EventEmitter<any>();

  constructor(private outsideSurveyService: OutsideSurveyService) {}

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit() {
    this.searchInput.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap((query) =>
          query.length < 1
            ? (this.searchResults = [])
            : this.outsideSurveyService.searchContacts(query)
        )
      )
      .subscribe((res: any) => {
        this.searchResults = res;
      });
  }

  onSelectResult(searchResult) {
    this.searchInput.setValue("");
    this.selectedContact = searchResult;
    this.selectResult.emit(this.selectedContact);
    this.menuTrigger.closeMenu();
    this.searchResults = [];
  }

  isFocus(bool: boolean) {
    setTimeout(() => {
      // without this click event on search result don't get fired.
      if (bool) this.menuTrigger.openMenu();
      else this.menuTrigger.closeMenu();
    }, 150);
  }

  onAddNewContact() {
    this.onSelectResult(null);
    this.newContact.emit();
  }
}
